// Чат поддержки — единая точка для всех кнопок «Поддержка» в приложении.
// Используется кнопкой 🎧 в шапке и модалкой поддержки.
export const SUPPORT_TELEGRAM = 'https://t.me/fund1ngsupport'
export const SUPPORT_TELEGRAM_HANDLE = '@fund1ngsupport'
